import { render, staticRenderFns } from "./RuleUseModal.vue?vue&type=template&id=c458bcc6&scoped=true"
import script from "./RuleUseModal.vue?vue&type=script&lang=js"
export * from "./RuleUseModal.vue?vue&type=script&lang=js"
import style0 from "./RuleUseModal.vue?vue&type=style&index=0&id=c458bcc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c458bcc6",
  null
  
)

export default component.exports